import { loadStripe } from '@stripe/stripe-js';

export const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY);

export const STRIPE_PLANS = {
  FREE: 'free',
  GROWTH: 'price_growth_monthly', // Replace with your actual Stripe price IDs
  GROWTH_YEARLY: 'price_growth_yearly',
  PROFESSIONAL: 'price_professional_monthly',
  PROFESSIONAL_YEARLY: 'price_professional_yearly',
};